import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bdba8e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_2 = { style: {"flex":"1"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "start",
  class: "icon-wrapper",
  style: { backgroundColor: '#3880ff' }
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-helmet-safety fa-lg fa-fw" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "start",
  class: "icon-wrapper",
  style: { backgroundColor: '#2dd36f' }
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calculator fa-lg fa-fw" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "start",
  class: "icon-wrapper",
  style: { backgroundColor: '#ffc409' }
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-users fa-fw" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bookmark fa-fw" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "start",
  class: "icon-wrapper",
  style: { backgroundColor: '#5260ff' }
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book fa-fw" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "start",
  class: "icon-wrapper",
  style: { backgroundColor: '#777' }
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog fa-fw" })
], -1))
const _hoisted_11 = { style: {"margin-left":"10px","margin-right":"10px"} }

import {
  IonApp, IonItem, IonLabel, IonRouterOutlet, IonContent, IonMenuToggle, IonList, IonSplitPane, IonAvatar,
  IonMenu, IonBadge, IonButton,
} from '@ionic/vue';
import { ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from './stores/auth.store';
import { useUserStore } from './stores/user.store';
import { getApi } from '@/helpers/api';
import { PeriodSkillsApi, PeriodTrainingsApi, DtoSkillCategory, MyPpfConfigApi, GetMenuResponse } from 'ppf-api-client';



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const categories = ref<DtoSkillCategory[]>([]);
const auth = useAuthStore();
const route = useRoute();
const isActiveUrl = (path: string) => path === route.fullPath;
const user = useUserStore();
const profilePicture = ref('/assets/img/default-user-icon.jpg');
const hasTrainingLicense = ref<boolean>(false);
const menuConfiguration = ref<GetMenuResponse>({
  showContracts: false,
  showSkills: false,
  showTeams: false,
  showTrainings: false,
  showCounters: false,
});
const skillService =  getApi(PeriodSkillsApi);
const trainingService = getApi(PeriodTrainingsApi);
const configService = getApi(MyPpfConfigApi);

//logout callback
const onLogout = function () {
  auth.logout();
};


//watch er on auth store. Triggered immediately after a change
watchEffect(async () => {
  if (auth.isLogged) {
    if (skillService) {
      categories.value = await skillService.periodSkillsCategoriesFromDate(auth.userId, new Date());
      trainingService.periodTrainingsHasLicense().then(v => hasTrainingLicense.value = v);
      configService.myPpfConfigGetMenu().then(v => menuConfiguration.value = v);

    }
  }
});
watchEffect(async () => {
  if (user.user?.profilePicture) {
    profilePicture.value = user.user.profilePicture;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), {
        "content-id": "menu-content",
        disabled: !_unref(auth).idToken
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonMenu), {
            "content-id": "menu-content",
            swipeGesture: false
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), { "force-overscroll": false }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_unref(IonList), { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonMenuToggle), { "auto-hide": false }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), {
                                button: menuConfiguration.value.showContracts,
                                "router-link": menuConfiguration.value.showContracts ? '/contracts' : '/',
                                class: _normalizeClass({ selected: isActiveUrl('/contracts') })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonAvatar), { slot: "start" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", { src: profilePicture.value }, null, 8, _hoisted_3)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(_unref(user) ? _unref(user).user?.personnel.userName : ''), 1),
                                      _createElementVNode("p", null, _toDisplayString(_unref(user) ? _unref(user).user?.contracts.map((c) => c.type).join(', ') : ''), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["button", "router-link", "class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonList), { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonMenuToggle), { "auto-hide": false }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), {
                                button: "",
                                "router-link": "/allocations",
                                class: _normalizeClass({ selected: isActiveUrl('/allocations') })
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_4,
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('p.home.allocation')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          }),
                          (menuConfiguration.value.showCounters)
                            ? (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                                key: 0,
                                "auto-hide": false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), {
                                    button: "",
                                    "router-link": "/counters",
                                    class: _normalizeClass({ selected: isActiveUrl('/counters') })
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_5,
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('p.home.counter')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (menuConfiguration.value.showTeams)
                            ? (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                                key: 1,
                                "auto-hide": false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), {
                                    button: "",
                                    "router-link": "/teams",
                                    class: _normalizeClass({ selected: isActiveUrl('/teams') })
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6,
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('p.home.team')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (menuConfiguration.value.showSkills)
                        ? (_openBlock(), _createBlock(_unref(IonList), {
                            key: 0,
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (c) => {
                                return (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                                  "auto-hide": false,
                                  key: c.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonItem), {
                                      button: "",
                                      "router-link": `/skill/${c.id}`,
                                      class: _normalizeClass({ selected: isActiveUrl(`/skill/${c.id}`) })
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          slot: "start",
                                          class: "icon-wrapper",
                                          style: _normalizeStyle({ backgroundColor: c.color || '#555' })
                                        }, _hoisted_8, 4),
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(c.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_unref(IonBadge), { slot: "end" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(c.count), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["router-link", "class"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (menuConfiguration.value.showTrainings && hasTrainingLicense.value)
                        ? (_openBlock(), _createBlock(_unref(IonList), {
                            key: 1,
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonMenuToggle), { "auto-hide": false }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), {
                                    button: "",
                                    "router-link": "/trainings",
                                    class: _normalizeClass({ selected: isActiveUrl('/trainings') })
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9,
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('p.home.training')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(IonList), { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonMenuToggle), { "auto-hide": false }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), {
                                button: "",
                                "router-link": "/settings",
                                class: _normalizeClass({ selected: isActiveUrl('/settings') })
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('p.home.settings')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(IonButton), {
                        expand: "block",
                        onClick: onLogout
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('p.home.logout')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRouterOutlet), {
            animated: false,
            id: "menu-content",
            swipeGesture: false
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})